
import React, { useState, useEffect } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { Filter, RotateCcw } from 'feather-icons-react/build/IconComponents';
import { setexpiredproduct_data } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Box } from 'react-feather';
import { DatePicker } from 'antd';
// import withReactContent from 'sweetalert2-react-content';
// import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
import Axios from 'axios';
import { API_BASE_URL, GET_EXPIRED } from '../../Config';

const ExpiredProduct = () => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    const dispatch = useDispatch();
    // const data = useSelector((state) => state.toggle_header);
    const dataSource = useSelector((state) => state.expiredproduct_data);

    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userDataSession.OrgId) {
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_EXPIRED}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        dispatch(setexpiredproduct_data(response.data.ResultData));
                        console.log(response.data, 'kkkkkkkkkkkkkkkkkk')
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    }, [dispatch, userDataSession]);


    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const toggleFilterVisibility = () => {
        setIsFilterVisible((prevVisibility) => !prevVisibility);
    };
    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    // const oldandlatestvalue = [
    //     { value: 'date', label: 'Sort by Date' },
    //     { value: 'newest', label: 'Newest' },
    //     { value: 'oldest', label: 'Oldest' },
    // ];

    const brands = [
        { value: 'chooseType', label: 'Choose Type' },
        { value: 'lenovo3rdGen', label: 'Lenovo 3rd Generation' },
        { value: 'nikeJordan', label: 'Nike Jordan' },
    ];

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    // const renderPrinterTooltip = (props) => (
    //     <Tooltip id="printer-tooltip" {...props}>
    //         Printer
    //     </Tooltip>
    // );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    // const renderCollapseTooltip = (props) => (
    //     <Tooltip id="refresh-tooltip" {...props}>
    //         Collapse
    //     </Tooltip>
    // );

    const columns = [

        {
            title: "Product",
            dataIndex: "Name",
            sorter: (a, b) => a.Name.length - b.Name.length,
        },

        {
            title: "Barcode",
            dataIndex: "BarCode",
            sorter: (a, b) => a.BarCode.length - b.BarCode.length,
        },

        {
            title: "Manufactured Date",
            dataIndex: 'ManufacturedDate',
            sorter: (a, b) => new Date(a.ManufacturedDate) - new Date(b.ManufacturedDate),
            render: (ManufacturedDate) => {
                const date = new Date(ManufacturedDate);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        },

        {
            title: "Expired Date",
            dataIndex: 'ExpiredDate',
            sorter: (a, b) => new Date(a.ExpiredDate) - new Date(b.ExpiredDate),
            render: (ExpiredDate) => {
                const date = new Date(ExpiredDate);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        },

        {
            title: "Description",
            dataIndex: "Description",
            sorter: (a, b) => a.Description.length - b.Description.length,
        },

        // {
        //     title: 'Actions',
        //     dataIndex: 'actions',
        //     key: 'actions',
        //     render: () => (
        //         <td className="action-table-data">
        //             <div className="edit-delete-action">
        //                 <Link className="me-2 p-2" to="#">
        //                     <i data-feather="edit" className="feather-edit"></i>
        //                 </Link>
        //                 <Link className="confirm-text p-2" to="#"  >
        //                     <i data-feather="trash-2" className="feather-trash-2" onClick={showConfirmationAlert}></i>
        //                 </Link>
        //             </div>
        //         </td>
        //     )
        // },
    ]

    const filteredData = dataSource.filter(item =>
        item && // Check if item is defined
        (item.Name && item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.BarCode && item.BarCode.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Description && item.Description.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    // const MySwal = withReactContent(Swal);

    // const showConfirmationAlert = () => {
    //     MySwal.fire({
    //         title: 'Are you sure?',
    //         text: 'You won\'t be able to revert this!',
    //         showCancelButton: true,
    //         confirmButtonColor: '#00ff00',
    //         confirmButtonText: 'Yes, delete it!',
    //         cancelButtonColor: '#ff0000',
    //         cancelButtonText: 'Cancel',
    //     }).then((result) => {
    //         if (result.isConfirmed) {

    //             MySwal.fire({
    //                 title: 'Deleted!',
    //                 text: 'Your file has been deleted.',
    //                 className: "btn btn-success",
    //                 confirmButtonText: 'OK',
    //                 customClass: {
    //                     confirmButton: 'btn btn-success',
    //                 },
    //             });
    //         } else {
    //             MySwal.close();
    //         }

    //     });
    // };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Expired Products</h4>
                                <h6>Manage your expired products</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
                        </ul>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="search-path">
                                    <div className="d-flex align-items-center">
                                        <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search">
                                            <Filter
                                                className="filter-icon"
                                                onClick={toggleFilterVisibility}
                                            />
                                            <span onClick={toggleFilterVisibility}>
                                                <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                                {/* <div className="form-sort">
                                    <Sliders className="info-img" />
                                    <Select
                                        className="select"
                                        options={oldandlatestvalue}
                                        placeholder="Newest"
                                    />
                                </div> */}
                            </div>
                            {/* /Filter */}
                            <div
                                className={`card${isFilterVisible ? " visible" : ""}`}
                                id="filter_inputs"
                                style={{ display: isFilterVisible ? "block" : "none" }}
                            >
                                <div className="card-body pb-0">
                                    <div className="row">
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <div className="input-blocks">
                                                <Box className="info-img" />

                                                <Select options={brands} className="select" placeholder="Choose Type" />

                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <div className="input-blocks">
                                                <div className="input-groupicon">
                                                    <DatePicker
                                                        selected={selectedDate}
                                                        onChange={handleDateChange}
                                                        type="date"
                                                        className="filterdatepicker"
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholder='Choose Date'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                                            <div className="input-blocks">
                                                <Link className="btn btn-filters ms-auto">
                                                    {" "}
                                                    <i data-feather="search" className="feather-search" />{" "}
                                                    Search{" "}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="loader m-auto"></div>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} />
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>

        </div>
    )
}

export default ExpiredProduct
